<ng-content select=".app-dialog-footer"></ng-content>
